import { OnInit, Component, Input, SimpleChanges, OnChanges } from '@angular/core';
import { AlertService } from 'src/app/shared/services/alert.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalService } from 'src/app/shared/global.service';
import { Router,  ActivatedRoute } from '@angular/router';
import { UrlService } from 'src/app/shared/services/url.service';
import { UtilService } from 'src/app/shared/services/util.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { CompensacioBicModel, CompensacionBicicletaBasicaDTO } from 'src/app/models/compensacionBici.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { ConfirmationModalOptions } from 'src/app/shared/models/modal.model';
import { AppSettings } from 'src/app/app.settings';
import { DetalleDominio } from 'src/app/models/detalleDominio.Model';
import { VariablesZonaCompartida } from 'src/app/shared/services/VariablesZonaCompartida';


@Component({
    selector: 'app-gestionar-incentivo-bici',
    templateUrl: './gestionar-incentivo-bici.component.html',
    styleUrls: ['./gestionar-incentivo-bici.component.scss']
})

export class GestionarIncentivoBicicletaComponent implements OnInit {
    FRAME_PDF = 'print_frame_pdf';
    tipoDocumento: string;
    numDocumento: string;
    progreso = 0;
    isBoss: boolean;
    pdfCompensacion: string;
    public compensacionBici: CompensacioBicModel;
    public compensacionSeleccionada: CompensacionBicicletaBasicaDTO = new CompensacionBicicletaBasicaDTO();
    public modalSolicitarIncentivo: ConfirmationModalOptions;
    public modalAprobarIncentivo: ConfirmationModalOptions;
    dominios: string[] = [DominiosService.DOMINIO_TURNO_INCENTIVO];
    listaDominios: DetalleDominio[];
    dominioTurno: DetalleDominio[];
    public puedeCompensar = false;
    
    constructor(
        public route: ActivatedRoute,
        public global: GlobalService,
        public urlService: UrlService,
        public spinner: NgxSpinnerService,
        public utilService: UtilService,
        public alertService: AlertService,
        public router: Router ) {

        this.modalSolicitarIncentivo =
            new ConfirmationModalOptions('Confirmación', ConstantesService.MSJ_SOL_INCENTIVO_BICICLETA,
                'SI', 'NO', 'fas fa-save', true, false, 'Solicitud de incentivo',
                null, 'btn-secondary');

        this.modalAprobarIncentivo =
                new ConfirmationModalOptions('Confirmación', ConstantesService.MSJ_APRO_INCENTIVO_BICICLETA,
                    'SI', 'NO', 'fas fa-save', true, false, 'Aprobación de incentivo',
                    null, 'btn-secondary');

    }
    

    ngOnInit() {
        this.reiniciarValores();
        this.validarInformacion();
        this.consultarDominios();
        this.comsultarPlanesCompesacion();
        
    }

    private reiniciarValores() {
        this.progreso = 0;
        this.pdfCompensacion = undefined;
        this.puedeCompensar = false; 
        this.compensacionSeleccionada = new CompensacionBicicletaBasicaDTO();
        // isBoss = false
    }

    /**
     * Regresa a la lista de funcionarios
     */
    public regresarListaFuncionarios() {
        this.global.zonaCompartida[VariablesZonaCompartida.DATOS_FUNCIONARIO_INCENTIVO_BICICLETA] = undefined;
        this.router.navigate(['incentivoBicicleta/']);
    }

    /**
     * Valida la informacion inicial si el plan es propio o de un empleado
     */
    private validarInformacion() {
        const datos = this.global.zonaCompartida[VariablesZonaCompartida.DATOS_FUNCIONARIO_INCENTIVO_BICICLETA];
        this.tipoDocumento = datos ? datos.tipoIdFuncionario : null;
        this.numDocumento = datos ? datos.numeroIdFuncionario : null;
        if (this.tipoDocumento && this.numDocumento) {
            this.isBoss = true;
        } else {
            this.tipoDocumento = sessionStorage.getItem(ConstantesService.TIPO_DOC_SESSSION);
            this.numDocumento = sessionStorage.getItem(ConstantesService.NUM_DOC_SESSSION);
        }

    }


    /**
     *  Metodo encargado de consultar los planes de compensacion del funcionario
     */
    private comsultarPlanesCompesacion() {
        this.reiniciarValores();
        this.spinner.show();
        const serviceProvider = 'compensacionPorFuncionario';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['tipoDocumento', this.tipoDocumento]);
        queryParams.push(['numDocumento', this.numDocumento]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
          this.urlService.hostAPI_FUNCIONARIOS );
        this.global.getGenerico(url).subscribe(
            data => {

                this.compensacionBici = data;
                this.barraProgreso();
                this.validarBotonIncentivo();
                this.spinner.hide();
            }, err => {
                 this.utilService.cathException(err, this.alertService , this.spinner);
            }
        );
    }

    /**
     * Metodo encargado de actualizar el compensatorio con la solicitud del funcionario
     */
    public solicitarCompensacion() {
        this.spinner.show();
        const serviceProvider = 'solicitarCompensacion';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['idCompensacion', this.compensacionSolicitada()]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
          this.urlService.hostAPI_FUNCIONARIOS );
        this.global.getGenerico(url).subscribe(
            data => {
                this.pdfCompensacion = data.mensaje;
                this.alertService.generateAlertSuccess('Solicitud exitosa', 'Se realizó la solicitud de certificado de tiempo para incentivo exitosamente');
                this.imprimir();
                this.reiniciarValores();
                this.comsultarPlanesCompesacion();
            }, err => {
                 this.utilService.cathException(err, this.alertService , this.spinner);
            }
        );
    }

    /**
     * Retorna el id del primer compensatorio del funcioinario
     */
    private compensacionSolicitada(): string {
        const compensacion: CompensacionBicicletaBasicaDTO =
            this.compensacionBici.compensacionBicicletaBasica.find( comp => comp.estado === DominiosService.ESTADO_INCENTIVO_BICI_COMPLETO );
        return compensacion.idCompesacion.toString();
    }

        /**
     * Retorna el id del primer compensatorio del funcioinario
     */
    private compensacionAprobar() {
        const compensacion: CompensacionBicicletaBasicaDTO =
            this.compensacionBici.compensacionBicicletaBasica.find( comp => comp.estado === DominiosService.ESTADO_INCENTIVO_BICI_PENDIENTE );
       this.compensacionSeleccionada.idCompesacion = compensacion.idCompesacion;
    }

    /**
     * Metodo encargado de aprobar el plan de compensatorio por parte del jefe o recursos humanos
     */
    public aprobarCompensacion() {
        this.spinner.show();
        this.compensacionAprobar();
        const serviceProvider = 'aprobarCompensacion';
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, null),
         this.urlService.hostAPI_FUNCIONARIOS );
        this.compensacionSeleccionada.aprobadoPor = sessionStorage.getItem(ConstantesService.SIA3_SESSSION);
        this.global.postGenerico(url, this.compensacionSeleccionada).subscribe(
            data => {
                this.reiniciarValores();
                this.comsultarPlanesCompesacion();                
            }, err => {
                 this.utilService.cathException(err, this.alertService , this.spinner);
            }
        );
    }

    private barraProgreso(){
        if(this.compensacionBici.diasParametroCompensacion && this.compensacionBici.diasParametroCompensacion !== 0) {
            let porcentaje = (this.compensacionBici.diasCompensacionActual / this.compensacionBici.diasParametroCompensacion) * 100 ;
            this.progreso =  Number.parseFloat(porcentaje.toFixed(2));
        }

    }

    private validarBotonIncentivo() {

        let compensacion: CompensacionBicicletaBasicaDTO;
        if (this.isBoss) {
            compensacion =  this.compensacionBici.compensacionBicicletaBasica.find( comp => comp.estado === DominiosService.ESTADO_INCENTIVO_BICI_PENDIENTE );            
            this.puedeCompensar = compensacion ? true : false;
        } else {
            compensacion =  this.compensacionBici.compensacionBicicletaBasica.find( comp => comp.estado === DominiosService.ESTADO_INCENTIVO_BICI_COMPLETO );
            this.modalSolicitarIncentivo.disabled = !compensacion;

        }

    }


    public confirmationModalSolicitud(event) {
        if (event[0] === true) {
            this.solicitarCompensacion();
        }
    }

    public confirmationModalAprobacion(event) {
        if (event[0] === true) {
            this.aprobarCompensacion();
        }
    }

    public validarFormulario() {
        if (    this.utilService.validarCamposObligatorios(this.compensacionSeleccionada.turnoIncentivo) 
                && this.utilService.validarCamposObligatorios(this.compensacionSeleccionada.fechaIncentivo) )  {
            this.modalAprobarIncentivo.disabled = false;
        } else {
            this.modalAprobarIncentivo.disabled = true;
        }
    }



    imprimir() {
        window.frames[this.FRAME_PDF].document.body.innerHTML = this.pdfCompensacion;
        window.frames[this.FRAME_PDF].window.focus();
        setTimeout(() => {
            window.frames[this.FRAME_PDF].window.print();
            window.frames[this.FRAME_PDF].document.body.innerHTML = '';
        }, 100);
    }


    public consultarDominios() {
        this.spinner.show();
        const serviceProvider = 'consultarDominios';
        const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, null), AppSettings.API_INIT_ENDPOINT);
        this.global.postGenerico(url, this.dominios).subscribe(
            data => {
                this.listaDominios = data;
                this.filtrarDominios(this.listaDominios);
                this.spinner.hide();
            }, err => {
                 this.utilService.cathException(err,this.alertService, this.spinner);
                // this.cathException('Ocurrio un error en la consulta de los dominios');
            }
        );
    }

    //
    private filtrarDominios(dominios: DetalleDominio[]) {
        this.dominioTurno =
            dominios.filter(dominio => dominio.detalleDominioPK.nombreDominio === DominiosService.DOMINIO_TURNO_INCENTIVO);

    }


    
}

